import { AfterViewInit, Component, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Store } from '@ngxs/store';
import { ScrollPanel } from 'primeng/scrollpanel';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { delay, filter, map } from 'rxjs/operators';
import { LayoutService } from 'src/app/services/layout.service';
import { LazyLoaderDirective } from 'src/app/shared/lazy-loader/lazy-loader.directive';
import { LazyLoaderService } from 'src/app/shared/lazy-loader/lazy-loader.service';
import { RightPanelService } from './rightpanel.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { BaseComponent } from 'src/app/shared/base.component';

@AutoUnsubscribe({arrayName: 'subscriptions'})
@Component({
    selector: 'app-rightpanel',
    templateUrl: './rightpanel.component.html',
    styleUrls: ['./rightpanel.component.scss']
})
export class AppRightPanelComponent extends BaseComponent implements OnInit, AfterViewInit {

    @ViewChild('scrollRightPanel', { static: false }) rightPanelMenuScrollerViewChild: ScrollPanel;

    private _lazyComponentDirectives$ = new BehaviorSubject<LazyLoaderDirective[]>(null);
    private _lazyComponentDirectives: LazyLoaderDirective[];
    clickInside: boolean;
    defaultRightPanel$$: any;
    @ViewChildren(LazyLoaderDirective)
    set lazyComponentDirectives(value: QueryList<LazyLoaderDirective>) {
        this._lazyComponentDirectives = value && value.toArray();
        if (this._lazyComponentDirectives) {
            this._lazyComponentDirectives$.next(this._lazyComponentDirectives);
        }
    }


    constructor(
        public service: RightPanelService,
        public layoutService: LayoutService,
        private store: Store,
        private lazyLoaderService: LazyLoaderService
    ) {
        super();
    }

    ngOnInit() {
        // user roles
    }

    ngAfterViewInit() {
        this.initializeListener();
        setTimeout(() => {
            if (this.rightPanelMenuScrollerViewChild) {
                this.rightPanelMenuScrollerViewChild.moveBar();
            }
        }, 100);

        this.initializeViewListener();
    }


    initializeViewListener() {
        const customView$ = this.store.select<string>(RightPanelService.customView);
        const layoutRightPanelActive$ = this.layoutService.currentLayout$.asObservable().pipe(map(layout => layout.rightPanelActive));

        this.subscriptions.push(combineLatest([layoutRightPanelActive$, customView$]).pipe(delay(100)).subscribe(([layoutRightPanelActive, customView]) => {
            if (layoutRightPanelActive || customView) {
                this.service.setOpenPanel(true);
            } else {
                this.service.setOpenPanel(false);
            }
        }));
    }

    @HostListener('click')
    click() {
        this.clickInside = true;
    }


    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (!this.clickInside) {
            if (this.service.openPanelSync) {
                this.service.setCurrentCustomView(null);
            }
        }

        this.clickInside = false;
    }

    initializeListener() {

        this.subscriptions.push(combineLatest([this._lazyComponentDirectives$.asObservable()])
            .pipe(filter(([tiles]) => (!!tiles && tiles.length > 0)), delay(0))
            .subscribe(async ([lazyComponentDirectives]) => {

                for (const directive of lazyComponentDirectives) {

                    if (directive && directive.appLazy) {
                        await this.lazyLoaderService.load(directive, directive.metadata);
                    }
                }
            }));
    }

}
